import React, { FC, memo, useContext } from 'react'
import { HeaderContainer, MainContainer } from './styles'
import { DirectoryItemTransport } from '../../transports/directory-transport'
import HeaderSection from '../../components/landing-page/header-section'
import { HeaderSectionTransport } from '../../transports/region-landing-page-transport'
import FooterSection from '../landing-page/footer-section'
import FooterSectionTransport from '../../transports/common/footer-section-transport'
import DirectorySection from './directory-section'

interface DirectoryPageProps {
    region: string
    directoryItems: DirectoryItemTransport[]
    firstName?: string
    sitePathname?: string
    isLoggedIn: boolean
    headerSection: HeaderSectionTransport
    footerSection: FooterSectionTransport
}

const DirectoryPage: FC<DirectoryPageProps> = ({
    region,
    directoryItems,
    firstName,
    sitePathname,
    isLoggedIn,
    headerSection,
    footerSection,
}) => {
    return (
        <MainContainer id="directory">
            <HeaderContainer>
                <HeaderSection
                    isLoggedIn={isLoggedIn}
                    firstName={firstName}
                    url=""
                    headerSection={headerSection}
                    sitePathname={sitePathname}
                    showVacationIdeasNavButton
                />
            </HeaderContainer>
            <DirectorySection region={region} directoryItems={directoryItems} />
            <FooterSection
                footerSection={footerSection}
                footerLogo={headerSection.navigationSectionResponse.navigation.logo}
                socialMediaLinks={headerSection.navigationSectionResponse.socialMediaLinks}
            />
        </MainContainer>
    )
}

export default memo(DirectoryPage)
